module.exports = __webpack_public_path__ + "img/recycle1.18a95cca.png";